export default val => {
  return {
    100: "待报价",
    200: "待确认",
    300: "待派车",
    400: "提货中",
    500: "在途中",
    600: "已送达",
    700: "确认送达",
    800: "已拒绝",
    1100: "已取消"
  }[val];
};



// WEBPACK FOOTER //
// ./src/filters/statusFormat.js